import { Component, OnInit, Input, Injectable, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray, AbstractControl } from '@angular/forms';
import { PatientDialogService } from 'src/app/services/Non-Master/PatientDialog.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { formatDate, DatePipe } from '@angular/common';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { tPatientModel } from 'src/app/models/tPatientModel';
import { tPatientService } from 'src/app/services/tPatient.service';
import { NewPatientDialogService } from 'src/app/services/Non-Master/NewPatientDialog.service';
import { tBookingService } from 'src/app/services/tBooking.service';
import { tBookingTimeModel } from 'src/app/models/tBookingModel';
import { SearchEmployeeDialogService } from 'src/app/services/Non-Master/SearchEmployeeDialog.service';
import { tEmployeeModel } from 'src/app/models/tEmployeeModel';
import { SearchItemIDDialogService } from 'src/app/services/Non-Master/SearchItemIDDialog.service';
import { tItemModel } from 'src/app/models/tItemModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { StatusMessage } from 'src/app/shared/StatusMessage';
import { AppSettings } from 'src/app/shared/AppSettings';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';
import { tBookAuxService } from 'src/app/services/tBookAux.service';
import { tBookAuxModel } from 'src/app/models/tBookAuxModel';
import { of } from 'rxjs';
import { DisplayData } from 'src/app/models/non-master-model/DisplayData';
import { ApiResultDialogService } from 'src/app/services/Non-Master/ApiResultDialog.service';
import { tEmployeeService } from 'src/app/services/tEmployee.service';
import { tShopModel } from 'src/app/models/tShopModel';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material';
import { tOnConsultService } from 'src/app/services/tOnConsult.service';
@Component({
  selector: 'app-booking-dialog',
  templateUrl: './booking-dialog.component.html',
  styles: ['./booking-dialog.component.css']
})

@Injectable()
export class BookingDialogComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private formBuilder: FormBuilder,
    private patientDialogService: PatientDialogService,
    private searchEmployeeDialogService: SearchEmployeeDialogService,
    private dateTimeConvertService: DateTimeConvertService,
    private tPatientService: tPatientService,
    private newPatientDialogService: NewPatientDialogService,
    private tBookingService: tBookingService,
    private searchItemIDDialogService: SearchItemIDDialogService,
    private ren: Renderer2,
    private datepipe: DatePipe,
    private apiResultHandlerService: ApiResultHandlerService,
    private apiResultDialogService: ApiResultDialogService,
    private tBookAuxService: tBookAuxService,
    private employeeService: tEmployeeService,
    private translate: TranslateService,
    private snackBar : MatSnackBar,
    private tOnConsultService : tOnConsultService,
    private datePipe : DatePipe
  ) {

    this.translate.get(['msg_caseDoctor_no_select_patient','msg_caseDoctor_no_caseDoctor']).subscribe(t=>this.i18n=t);

  }

  get f() { return this.editForm.controls; }

  // form
  bntStyle: string;
  submitted = false;
  editForm: FormGroup;
  formValidSuccessSubmitted = false;
  ecTypeSelectList: tEmployeeModel[];
  bookingDateDisplay: string
  selectedPatient: tPatientModel = new tPatientModel();

  selectedEmpolyee1: tEmployeeModel = new tEmployeeModel();
  selectedEmpolyee1_Display: string;
  selectedItemService1: tItemModel = new tItemModel();
  newPatient=false;
  public selectedItemService1_Display: string;

  selectedPatientCheck="searchPatient";
  selectedEmpolyee2: tEmployeeModel = new tEmployeeModel();
  public selectedEmpolyee2_Display: string;
  selectedItemService2: tItemModel = new tItemModel();
  public selectedItemService2_Display: string;

  selectedEmpolyee3: tEmployeeModel = new tEmployeeModel();
  selectedEmpolyee3_Display: string;
  selectedItemService3: tItemModel = new tItemModel();
  selectedItemService3_Display: string;


  selectedEmpolyee4: tEmployeeModel = new tEmployeeModel();
  selectedEmpolyee4_Display: string;
  selectedItemService4: tItemModel = new tItemModel();
  selectedItemService4_Display: string;

  bookingPatientDisplayName: string;

  timeSlotList: tBookingTimeModel[];
  bookingAuxList: tBookAuxModel[];

  TAG = 'BookingDialogComponent';
  // displayMsg: string;
  @Input() action: string;
  // @Input() status: string;
  @Input() tableKeyValue: string;
  // @Input() msg: string;
  @Input() bookingDate: Date;
  @Input() bookingTimeSlotDisplay: string;
  @Input() bookingTimeSlotID: number;
  @Input() selectedDoctorID:string; //employeeID

  bookingAuxData = [];
  i18n;

  ngOnInit() {

    this.bntStyle = 'btn-default';

    // this.log.i(this.TAG, "this.bookingDate = " + this.bookingDate);
    this.bookingDateDisplay = this.dateTimeConvertService.ConvertCurrentDayWeek(this.bookingDate);

    this.editForm = this.formBuilder.group({
      shopID: [NavigationComponent.selectedShopID],
      bkBookingNumber: [],
      bkPatientID: ['', [Validators.required]],
      bkBookedDate: [],
      bkBookedTimeSlot: [this.bookingTimeSlotID],
      bkBookingStatus: ['OPEN'],
      bkBookAuxIDAll: new FormArray([]),

      bkBookAuxID: [],
      bkBookAuxName: ['', ''],

      bkItemID1: ['', ''],
      bkItemDescMobile1: [''],
      bkTherapistID1: ['', ''],
      bkTherapistName1: ['', ''],

      bkItemID2: ['', ''],
      bkItemDescMobile2: [''],
      bkTherapistID2: ['', ''],
      bkTherapistName2: ['', ''],

      bkItemID3: ['', ''],
      bkItemDescMobile3: [''],
      bkTherapistID3: ['', ''],
      bkTherapistName3: ['', ''],
      bkDoctorID: ['', ''],
      bkDoctorName: ['', ''],
      bkPatientPhone: ['', [Validators.required]],

      lastModifyDatetime: ['', ''],
      lastModifyUserID: [],
      bkBookRemark: ['', ''],


      bkItemID4: ['', ''],
      bkItemDescMobile4: [''],
      bkTherapistID4: ['', ''],
      bkTherapistName4: ['', ''],
      bkPatientName: ['', [Validators.required]]

    });
    this.getEC_AllowSelectList();


  }

  getAllData(): void {

    this.tBookingService.getBookingTimeSlot().subscribe(data => {
      this.timeSlotList = data;
      //    this.log.i(this.TAG, 'getBookingTimeSlot dataList = ' + JSON.stringify(this.timeSlotList));
    });

    this.tBookAuxService.getDataByInactiveStatus(NavigationComponent.selectedShopID, 'N').subscribe(data => {
      this.bookingAuxList = data.sort((a,b)=>a.bookAuxSeq-b.bookAuxSeq);
      //  this.log.i(this.TAG, 'bookAux bookingAuxList = ' + JSON.stringify(this.bookingAuxList));

      // getcheckbox
      if (this.bookingAuxList.length > 0) {
        this.makeBookingAuxCheckBox(this.bookingAuxList);
      }

    });

    // auto open when start
    this.searchPatientID();



  }


  cancel() {
    this.log.i(this.TAG, 'do cancel');
    this.activeModal.close('Close click');

  }

  searchPatientID() {
    this.log.i(this.TAG, 'searchPatientID');


    // this.openPatientDialogModel(MastersKeyStringValue.ACTION_YNDialog);
    this.patientDialogService.openDialog().result.then((result) => {

      if(result!="newPatient"){
          console.log(result);
      this.selectedPatient = result;
      const {patientChiName,patientID,patientSurname} = this.selectedPatient;
      this.bookingPatientDisplayName = patientSurname ? `${patientChiName}   ${patientSurname} (${patientID})` : `${patientChiName} (${patientID})`;

      this.editForm.patchValue({
        bkPatientID : this.selectedPatient.patientID,
        bkPatientPhone : this.selectedPatient.patientPhone,
        bkPatientName:this.selectedPatient.patientChiName
      });

      this.getPatientLastPhysioInfo();
      }else{
        this.newPatientRecord();
    //    this.newPatient=true;

      }


    }, (reason) => {
      // on dismiss
      this.log.i(this.TAG, 'searchPatientID reason = ' + reason);

    });
  }

  searchService(caseNum: number) {
    this.log.i(this.TAG, 'searchService caseNum = ' + caseNum);


    this.searchItemIDDialogService.openDialogWithSelectFilter(SearchItemIDDialogService.Filter_Search_Service_Only)
      .result.then((result) => {
        this.log.i(this.TAG, 'searchService data = ' + result);

        if (caseNum === 1) {
          this.selectedItemService1 = result;
          this.log.i(this.TAG, 'searchService caseNum = ' + caseNum + ' , selectedItemService1_Display = '
            + this.selectedItemService1_Display);

          (<FormControl>this.editForm.controls['bkItemID1']).setValue(this.selectedItemService1.itemID);
          (<FormControl>this.editForm.controls['bkItemDescMobile1']).setValue(this.selectedItemService1.itemDesc);

          this.selectedItemService1_Display = this.selectedItemService1.itemDesc + ' (' + this.selectedItemService1.itemID + ')';


        } else if (caseNum === 2) {
          this.selectedItemService2 = result;

          (<FormControl>this.editForm.controls['bkItemID2']).setValue(this.selectedItemService2.itemID);
          (<FormControl>this.editForm.controls['bkItemDescMobile2']).setValue(this.selectedItemService2.itemDesc);

          this.selectedItemService2_Display = this.selectedItemService2.itemDesc + ' (' + this.selectedItemService2.itemID + ')';

        } else if (caseNum === 3) {
          this.selectedItemService3 = result;

          (<FormControl>this.editForm.controls['bkItemID3']).setValue(this.selectedItemService3.itemID);
          (<FormControl>this.editForm.controls['bkItemDescMobile3']).setValue(this.selectedItemService3.itemDesc);

          this.selectedItemService3_Display = this.selectedItemService3.itemDesc + ' (' + this.selectedItemService3.itemID + ')';

        } else if (caseNum === 4) {
          this.selectedItemService4 = result;

          (<FormControl>this.editForm.controls['bkItemID4']).setValue(this.selectedItemService4.itemID);
          (<FormControl>this.editForm.controls['bkItemDescMobile4']).setValue(this.selectedItemService4.itemDesc);

          this.selectedItemService4_Display = this.selectedItemService4.itemDesc + ' (' + this.selectedItemService4.itemID + ')';

        }

        // this.bookingPatientDisplayName = this.selectedPatient.patientChiName + " ("+this.selectedPatient.patientID+")";

      }, (reason) => {
        this.log.i(this.TAG, 'searchService reason = ' + reason);

      });
  }

  searchEmployee(caseNum: number) {
    this.log.i(this.TAG, 'searchEmployee caseNum = ' + caseNum);

    this.searchEmployeeDialogService.openDialog(caseNum).result.then((result) => {
      // this.log.i(this.TAG, 'searchEmployee data = ' + result);

      if (caseNum === 1) {
        this.selectedEmpolyee1 = result;

        (<FormControl>this.editForm.controls['bkTherapistID1']).setValue(this.selectedEmpolyee1.employeeID);
        (<FormControl>this.editForm.controls['bkTherapistName1']).setValue(this.selectedEmpolyee1.employeeChiName);
        this.selectedEmpolyee1_Display = this.selectedEmpolyee1.employeeChiName + ' (' + this.selectedEmpolyee1.employeeID + ')';

      } else if (caseNum === 2) {
        this.selectedEmpolyee2 = result;

        (<FormControl>this.editForm.controls['bkTherapistID2']).setValue(this.selectedEmpolyee2.employeeID);
        (<FormControl>this.editForm.controls['bkTherapistName2']).setValue(this.selectedEmpolyee2.employeeChiName);

        this.selectedEmpolyee2_Display = this.selectedEmpolyee2.employeeChiName + ' (' + this.selectedEmpolyee2.employeeID + ')';
      } else if (caseNum === 3) {
        this.selectedEmpolyee3 = result;
        // this.editForm.get('bkTherapistID3').setValue(this.selectedEmpolyee3.employeeID);
        (<FormControl>this.editForm.controls['bkTherapistID3']).setValue(this.selectedEmpolyee3.employeeID);
        (<FormControl>this.editForm.controls['bkTherapistName3']).setValue(this.selectedEmpolyee3.employeeChiName);

        this.selectedEmpolyee3_Display = this.selectedEmpolyee3.employeeChiName + ' (' + this.selectedEmpolyee3.employeeID + ')';

      } else if (caseNum === 4) {
        this.selectedEmpolyee4 = result;
        (<FormControl>this.editForm.controls['bkTherapistID4']).setValue(this.selectedEmpolyee4.employeeID);
        (<FormControl>this.editForm.controls['bkTherapistName4']).setValue(this.selectedEmpolyee4.employeeChiName);

        this.selectedEmpolyee4_Display = this.selectedEmpolyee4.employeeChiName + ' (' + this.selectedEmpolyee4.employeeID + ')';

      }


      // this.bookingPatientDisplayName = this.selectedPatient.patientChiName + " ("+this.selectedPatient.patientID+")";

    }, (reason) => {
      this.log.i(this.TAG, 'searchEmployee reason = ' + reason);

    });

  }

  confirm() {
    var checkPatientPhone=this.trimLeadingSpaces(this.editForm.get("bkPatientPhone").value.toString());
    var checkPatientName= this.trimLeadingSpaces(this.editForm.get("bkPatientName").value.toString());
    this.editForm.get("bkPatientPhone").setValue(checkPatientPhone);
    this.editForm.get("bkPatientName").setValue(checkPatientName);
      if(this.editForm.get('bkPatientID').value=="newPatient"){
        if(this.editForm.invalid) return this.snackBar.open('Please enter Patient Name and Tel.' ,'OK',{duration:3000});
      }else{
         if(this.editForm.invalid) return this.snackBar.open('No Patient selected' ,'OK',{duration:3000});
      }


      this.submitted = true;

      this.log.i(this.TAG, 'do confirm patientID' + this.selectedPatient.patientID + ' , bookedDate = ' + this.editForm.get('bkBookedDate'));

      if (this.editForm.valid) {
        this.formValidSuccessSubmitted = true;

        (<FormControl>this.editForm.controls['bkBookedDate']).setValue(this.datepipe.transform(this.bookingDate, 'yyyy-MM-dd'));

        (<FormControl>this.editForm.controls['lastModifyUserID']).setValue(NavigationComponent.userID);

        const auxList: tBookAuxModel[] = new Array();
        const selectedOrderIds = this.editForm.value.bkBookAuxIDAll
          .map((v, i) => (v ? this.bookingAuxList[i].bookAuxID : null))
          .filter(v => v !== null);

        this.log.i(this.TAG, 'selectedOrderIds data = ' + selectedOrderIds
          + ' , selectedOrderIds size = ' + selectedOrderIds.length);

        // for (var pp = 0; pp < this.bookingAuxList.length; pp++) {
        //   if (this.editForm.value.)
        // }
        for (let pp = 0; pp < this.bookingAuxList.length; pp++) {
          for (let qq = 0; qq < selectedOrderIds.length; qq++) {
            if (selectedOrderIds[qq] === this.bookingAuxList[pp].bookAuxID) {
              auxList.push(this.bookingAuxList[pp]);
              break;
            }
          }
        }
        // this.log.i(this.TAG, 'auxList data = ' + JSON.stringify(auxList).toString());

        (<FormControl>this.editForm.controls['bkBookAuxID']).setValue(JSON.stringify(auxList).toString());

        this.log.i(
          this.TAG,
          "onSubmit data = " + JSON.stringify(this.editForm.value)
        );


        //alert user , the patient has appointment on the date, are you still to create booking
        const shopID = NavigationComponent.selectedShopID;
        const { bkPatientID, bkBookedDate } = this.editForm.value; // date format : yyyy-MM-dd
        this.tBookingService
          .getBookingByPatientAndDate(
            shopID.toString(),
            bkPatientID,
            bkBookedDate
          )
          .subscribe((bookings) => {
            // console.table(bookings);

            if (bookings.data.length > 0 && bkPatientID!="newPatient") {
              const action = MastersKeyStringValue.ACTION_YNDialog;
              const timeSlot = bookings.data[0].bookingTime;
              const arrivalDateTime = bookings.data[0].arrivalDateTime;
              let message = "";
              if(bookings.data[0].bkBookingStatus == "ARRIVE"){
                this.translate.get("cBooking_warning_has_already_checkIn_booking",{ID:bkPatientID,Name:this.editForm.get('bkPatientName').value,arrivalDateTime:arrivalDateTime}).subscribe((x) => (message = x));
              }else{
                this.translate.get("cBooking_warning_duplicate__on_same_date",{ID:bkPatientID,Name:this.editForm.get('bkPatientName').value,timeSlot:timeSlot}).subscribe((x) => (message = x));
              }
              const messageBox = new DisplayData();
              messageBox.displayData6 = message;
              messageBox.displayData6_Style = {color:'red'};

              this.apiResultDialogService
                .openDialogV2(action,'','', messageBox)
                .result.then((x) => {
                  // console.log("fuck = "+ x);
                  if(x === 'Y'){
                    this.createBooking();
                  }else{
                    this.submitted = true;
                    this.formValidSuccessSubmitted = false;
                  }
                },reject=>{
                  //when click dialog
                  console.log("R : "+reject);
                  this.submitted = true;
                  this.formValidSuccessSubmitted = false;
                });
            } else {
              this.createBooking();
            }



          });



      }


  }
  trimLeadingSpaces(str: any): string {

      return str.replace(/^\s+/, '');

  }
  createBooking(){
          //create booking
          this.tBookingService.addData(this.editForm.value).subscribe(
            (data: any) => {
              this.log.i(
                this.TAG,
                "onSubmit success , data = " + JSON.stringify(data)
              );

              const returnData: any = data;

              // just close the dialog if success
              if (returnData.statusCode === StatusMessage.Status_OK) {
                this.activeModal.close(StatusMessage.Status_OK);
              }

              const diaplayData = new DisplayData();
              if (data.isSuccess == true) {
                diaplayData.displayData1 = "Saved";
                diaplayData.displayData2 = this.editForm.get("bkPatientName").value;
                diaplayData.displayData3 = "";
                diaplayData.displayData4 = "";
                diaplayData.displayData5 = "";

                // show result dialog
                this.apiResultHandlerService.ResultHandlerWithDisplayDate(
                  data,
                  AppSettings.Path_Booking + AppSettings.PATH_NEW,
                  "",
                  diaplayData
                );
                // refresh
              } else {
                if (data.data == "duplicate") {
                  var timeSlot = this.timeSlotList.find(
                    (p) =>
                      p.bookingTimeID ==
                      this.editForm.get("bkBookedTimeSlot").value
                  ).bookingTime;

                  var returnDisplayMsg = "";
                  this.translate
                    .get("ReturnStatus_Fail")
                    .subscribe((res: string) => {
                      returnDisplayMsg = res;
                    });
                  this.activeModal.dismiss("delete fail");

                  returnDisplayMsg +=
                    "\n" +
                    "Patient " +
                    this.bookingPatientDisplayName +
                    "already has an appointment scheduled." +
                    "\n" +
                    "Please search for the existing appointment to make any necessary modifications.";

                  this.openConfirmModal(
                    MastersKeyStringValue.STATUS_FAIL,
                    returnDisplayMsg
                  );
                }
              }
            },
            (err) => {
              this.log.i(this.TAG, "onsubmit error = " + err.status);
              this.apiResultDialogService.openDialog(
                MastersKeyStringValue.ACTION_MessageDialog,
                "",
                MastersKeyStringValue.STATUS_SUCCESS,
                this.apiResultDialogService.GetErrorMsg(err.status)
              );
              this.formValidSuccessSubmitted = false;
            }
          );
  }

  openConfirmModal(status, msg) {
    this.log.i(this.TAG, 'openConfirmModal action = ' + this.action);
    this.log.i(this.TAG, "delete success... return this.tableKeyValue = " + this.tableKeyValue);

     this.apiResultDialogService.openDialog(MastersKeyStringValue.ACTION_MessageDialog, this.tableKeyValue, status, msg);


  }
  onAuxChange(auxID) {
    this.log.i(this.TAG, 'onAuxChange auxID = ' + auxID);
    for (let i = 0; i < this.bookingAuxList.length; i++) {
      if (auxID === this.bookingAuxList[i].bookAuxID) {
        (<FormControl>this.editForm.controls['bkBookAuxName']).setValue(this.bookingAuxList[i].bookAuxName);

        break;
      }
    }
  }

  newPatientRecord() {
    this.log.i(this.TAG, 'do newPatientRecord');
    this.newPatient=true;
    this.editForm.get('bkPatientName').setValue('');
    this.editForm.get('bkPatientPhone').setValue('');
    this.editForm.get('bkPatientID').setValue('newPatient');
    this.bookingPatientDisplayName='newPatient';
    /*
    this.newPatientDialogService.openDialog().result.then((result) => {
      // on close
      this.log.i(this.TAG, 'searchPatientID data = ' + result);
      this.selectedPatient = result;
      (<FormControl>this.editForm.controls['bkPatientID']).setValue(this.selectedPatient.patientID);
      this.bookingPatientDisplayName = this.selectedPatient.patientChiName + ' (' + this.selectedPatient.patientID + ')';


      (<FormControl>this.editForm.controls['bkPatientPhone']).setValue(this.selectedPatient.patientPhone);

    }, (reason) => {
      // on dismiss
      this.log.i(this.TAG, 'searchPatientID reason = ' + reason);

    });
*/
  }


  setDatePickerZ() {
    const el = document.getElementsByClassName('mat-datepicker-popup').item(0);
    this.ren.setStyle(el, 'z-index', '1500');
  }

  ClearSelectBookAux() {
    (<FormControl>this.editForm.controls['bkBookAuxID']).setValue(0);
    (<FormControl>this.editForm.controls['bkBookAuxName']).setValue('');
  }

  ClearSelectedItem(caseNum: number) {
    this.log.i(this.TAG, 'ClearSelectedItem caseNum = ' + caseNum);

    if (caseNum === 1) {
      this.selectedItemService1 = null;
      this.selectedItemService1_Display = '';


      (<FormControl>this.editForm.controls['bkItemID1']).setValue('');
      (<FormControl>this.editForm.controls['bkItemDescMobile1']).setValue('');
    } else if (caseNum === 2) {
      this.selectedItemService2 = null;
      this.selectedItemService2_Display = '';


      (<FormControl>this.editForm.controls['bkItemID2']).setValue('');
      (<FormControl>this.editForm.controls['bkItemDescMobile2']).setValue('');
    } else if (caseNum === 3) {

      this.selectedItemService3 = null;
      this.selectedItemService3_Display = '';

      (<FormControl>this.editForm.controls['bkItemID3']).setValue('');
      (<FormControl>this.editForm.controls['bkItemDescMobile3']).setValue('');
    }

  }

  ClearSelectedEmpolyee(caseNum: number) {
    this.log.i(this.TAG, 'ClearSelectedEmpolyee caseNum = ' + caseNum);

    if (caseNum === 1) {
      this.selectedEmpolyee1 = null;
      this.selectedEmpolyee1_Display = '';
      (<FormControl>this.editForm.controls['bkTherapistID1']).setValue('');
      (<FormControl>this.editForm.controls['bkTherapistName1']).setValue('');

    } else if (caseNum === 2) {
      this.selectedEmpolyee2 = null;
      this.selectedEmpolyee2_Display = '';

      (<FormControl>this.editForm.controls['bkTherapistID2']).setValue('');
      (<FormControl>this.editForm.controls['bkTherapistName2']).setValue('');
    } else if (caseNum === 3) {
      this.selectedEmpolyee3 = null;
      this.selectedEmpolyee3_Display = '';

      (<FormControl>this.editForm.controls['bkTherapistID3']).setValue('');
      (<FormControl>this.editForm.controls['bkTherapistName3']).setValue('');

    } else if (caseNum === 4) {
      this.selectedEmpolyee4 = null;
      this.selectedEmpolyee4_Display = '';

      (<FormControl>this.editForm.controls['bkTherapistID4']).setValue('');
      (<FormControl>this.editForm.controls['bkTherapistName4']).setValue('');

    }


  }

  // checkbox
  makeBookingAuxCheckBox(bookAuxList: tBookAuxModel[]) {

    of(bookAuxList).subscribe(bookAuxList => {
      this.bookingAuxData = bookAuxList;
      this.addCheckboxes();
    });
  }

  private addCheckboxes() {
    this.bookingAuxData.forEach((o, i) => {
      // const control = new FormControl(i === 0); // if first item set to true, else false

      const control = new FormControl();
      (this.editForm.controls.bkBookAuxIDAll as FormArray).push(control);

      // const control = this.editForm.controls.bkBookAuxIDAll as FormArray;
      // control.push(control);
    });
  }


  GetAuxListAll(form){
    // editForm.controls.bkBookAuxIDAll.controls
    var auxListForm: FormGroup = this.formBuilder.group({
      bkBookAuxIDAll: new FormArray([]),
    });

    return form.controls;
  }

  changeTherapistID() {
    this.log.i(this.TAG, "do changeTherapistID");
    for (let i = 0; i < this.ecTypeSelectList.length; i++) {
      // this.ecTypeSelectList[i].fromToWH = this.editForm.get('fromToWH').value;

      if (this.ecTypeSelectList[i].employeeID == this.editForm.get('bkDoctorID').value) {
        (<FormControl>this.editForm.controls['bkDoctorName']).setValue(this.ecTypeSelectList[i].employeeChiName);
        break;
      }
      // this.log.i(this.TAG, i + ' , fromToWH = ' + this.ecTypeSelectList[i].fromToWH + ' ,whWhseID.whWhseID = ' + this.editForm.get('fromToWH').value);

    }

    // this.dataSource = new MatTableDataSource<tInvtModel>(this.dataList);

  }

  getEC_AllowSelectList() {
    // ecAllowSelectList
    this.employeeService.getEmployeeTypeList(NavigationComponent.selectedShopID, 5).subscribe(data => {
      // this.timeSlotList = data;
      // this.log.i(this.TAG, 'getEmployeeTypeList  = ' + JSON.stringify(data));

      this.ecTypeSelectList = [];
      //filter
      for (var i = 0; i < data.empolyeeList.length; i++) {
        //check need put
        var checkingEmployeeShopList: tShopModel[] = JSON.parse(data.empolyeeList[i].employeeRemark1);

        for (var p = 0; p < checkingEmployeeShopList.length; p++) {
          if (checkingEmployeeShopList[p].shopID == NavigationComponent.selectedShopID) {
            this.ecTypeSelectList.push(data.empolyeeList[i]);
            break;
          }
        }

      }

      //set default ec
      const selectedDoctor = this.ecTypeSelectList.find(emp=>emp.employeeID === this.selectedDoctorID);
      if (selectedDoctor) {
        (<FormControl>this.editForm.controls['bkDoctorName']).setValue(selectedDoctor.employeeChiName);
        (<FormControl>this.editForm.controls['bkDoctorID']).setValue(selectedDoctor.employeeID);
      }
      this.getAllData();
      // this.ecTypeSelectList = data.empolyeeList;
    }, error => {
      this.log.i(this.TAG, 'error = ' + JSON.stringify(error));
    });

  }

  changeBookingDate(value:any){
    this.bookingDate=value;
    this.log.i("changeValue",this.bookingDate);
    (<FormControl>this.editForm.controls['bkBookedDate']).setValue(this.datepipe.transform(value, 'yyyy-MM-dd'));

  }

  getCaseDoctorName(){
    if(!this.selectedPatient) return this.i18n.msg_caseDoctor_no_select_patient
    if(!this.selectedPatient.patientCaseDoctorID) return this.i18n.msg_caseDoctor_no_caseDoctor;

    const caseDr = this.ecTypeSelectList.find(emp=>emp.employeeID === this.selectedPatient.patientCaseDoctorID).employeeChiName;

    return caseDr;
  }

  patientLastPhysioRemark = "";
  patientLastPhysio = {
    therapistName:'',
    lastDate:''
  };

  getPatientLastPhysioInfo(){
    const {patientID} = this.selectedPatient;
    const shopID = NavigationComponent.selectedShopID.toString();
    this.tOnConsultService.getLastPhysioInfo(shopID,patientID).subscribe(x=>{
      if(x.length > 0){
        const info = x[x.length-1];
        const lastDate = this.datePipe.transform(info.endDateTime,AppSettings.dateFormat);
        this.patientLastPhysio.lastDate = lastDate;
        this.patientLastPhysio.therapistName = info.cltdTherapistName;
        this.patientLastPhysioRemark = "";
      }else{
        this.patientLastPhysioRemark = "";
      }
    });
  }


  newPatientChecked(value: string) {

      this.editForm.get('bkPatientName').setValue('');
      this.editForm.get('bkPatientPhone').setValue('');
      this.editForm.get('bkPatientID').setValue('');


    this.selectedPatientCheck = value;
    if(value=="newPatient"){
      this.newPatient=true;
      this.editForm.get('bkPatientID').setValue('newPatient');
    }else{
      this.newPatient=false;
    }
   // this.presHead.remark4=this.selectedLanguage;
  }
}

